import {ExplanationTypeEnum} from '@doltech/utils/lib/constants';
import {types as t} from 'mobx-state-tree';

import {AbstractReadingExplanation} from '../_extends/reading-explanation.store';

export const MainIdeaExplanationStore = AbstractReadingExplanation.named('MainIdeaExplanation')
  .props({
    type: ExplanationTypeEnum.MAIN_IDEA,
    simplify: t.maybeNull<any>(t.string),
  })
  .actions((self) => ({
    setSimplify(simplify: any) {
      self.simplify = JSON.stringify(simplify);
    },
  }));

